import { Refinement } from 'lib/Refinement/types'

import CustomRatingRefinementList from 'components/Filters/RatingFilter/CustomRatingRefinementList'

export const KEY = 'stats.averageReviewRatingBuckets'

export const ratingFilterRefinement: Refinement = {
  getQueryParamValue: ({ refinementList }) =>
    refinementList &&
    refinementList[KEY] && {
      rating: refinementList[KEY].join('_'),
    },
  getStateValue: ({ rating }) =>
    rating && {
      refinementList: {
        [KEY]: (rating as string).split('_'),
      },
    },
}

const RatingFilter = (): JSX.Element => (
  <CustomRatingRefinementList attribute={KEY} />
)

export default RatingFilter
